import Cookies from 'js-cookie';
import React, { useState } from 'react';

export default function useHandleFormData() {
  const IdPatient = JSON.parse(
    Cookies.get('user') || ''
  )?.IdPatient;
  const [formProps, setFromProps] = useState({
    ImageOrFile: '',
    IdPatient: IdPatient,
    IdConfer: 0,
    IdType: '',
    NameType: '',
    TypeConferId: 0,
    TypeConferName: 'اطلاعات فردي',
    NameFile: '',
    Description: '',
    DateMadrak: '',
    base64File: '',
  });

  return [formProps, setFromProps];
}
